import { useState } from 'react';
import Input from '../../components/Input';
import axios from "axios";
import { appId, ticketBaseURL } from '../../config/api';

const ContactUs = () => {
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [question, setQuestion] = useState<string>("");
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const onChangePhoneNumber = (value: string) => {
    const { length } = value;

    const regex = () => value.replace(/[^\d.]+/g, '');

    const areaCode = () => `(${regex().slice(0, 3)})`;

    const firstSix = () => `${areaCode()} ${regex().slice(3, 6)}`;

    const trailer = (start: number) => `${regex().slice(start, regex().length)}`;
    if (length < 3) {
      setPhone(regex());
    } else if (length >= 3 && length < 10) {
      setPhone(`${areaCode()} ${trailer(3)}`);
    } else if (length === 5) {
      setPhone(`${areaCode().replace(")", "")}`);
    } else if (length >= 10 && length < 15) {
      setPhone(`${firstSix()}-${trailer(6)}`);
    }
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(
        `${ticketBaseURL}customerEnquiry`,
        {
          email,
          name,
          question,
          applicationId: appId,
          phone,
          created: new Date(),
        },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      resetForm();
      setSubmitted(true);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setEmail("");
    setName("");
    setPhone("");
    setQuestion("");
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 to-blue-50 min-h-screen">
      <section className="bg-primary text-white text-center py-20 px-6">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-4">📬 Contact Us</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          We are here to help. Open a ticket or drop us a line and we'll get back to you within 24-48 business hours.
        </p>
      </section>

      <section className="py-16 px-6 max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-gray-800 text-center mb-12">Our Locations</h2>
        <div className="flex items-center justify-center">
          <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-lg transition">
            <h3 className="text-2xl font-bold mb-2 text-primary">USA Sugar Land</h3>
            <p className="text-gray-700 text-lg">
              54 Sugar Creek Center Blvd STE 300,<br />
              Sugar Land, TX 77478
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 px-6 max-w-3xl mx-auto">
        <h2 className="text-4xl font-bold text-gray-800 text-center mb-6">Drop us a line</h2>
        <p className="text-center text-gray-600 mb-12">
          Fill out the form below and our customer support team will get back to you.
        </p>

        {submitted && (
          <div className="mb-6 text-center text-green-600 font-semibold">
            Thank you! We'll be in touch soon.
          </div>
        )}

        <form className="bg-white p-8 rounded-2xl shadow-md space-y-6" onSubmit={handleSubmit}>
          <div className="grid sm:grid-cols-2 gap-4">
            <Input type="text" label="Name" inputValue={name} setInputValue={setName} pattern={''} title={''} />
            <Input type="email" label="Email Address" inputValue={email} setInputValue={setEmail} pattern={''} title={''} />
          </div>

          <Input
            type="text"
            label="Phone Number"
            pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
            title="Please Enter a 10 digits numbers."
            inputValue={phone}
            setInputValue={onChangePhoneNumber}
          />

          <textarea
            placeholder="Your Question"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            className="w-full border border-gray-200 rounded-lg p-3 text-gray-700 focus:outline-none focus:border-2 focus:border-primary"
            rows={6}
            required
          />

          <button
            type="submit"
            disabled={loading}
            className={`bg-primary hover:bg-blue-600 text-white font-semibold py-3 px-8 rounded-full transition w-full flex items-center justify-center gap-2 ${loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
          >
            {loading && (
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                ></path>
              </svg>
            )}
            {loading ? "Submitting..." : "Send Message"}
          </button>
        </form>
      </section>
    </div>
  );
}

export default ContactUs;